import { useLayoutEffect } from 'react';
import { getHiddenColumns, getInvisibleColumns } from '../table-helpers/get-hidden-columns';
export const useHiddenColumnsSetter = (columns, tableInstance, skipHiddenColumnsSetter = false) => {
    useLayoutEffect(() => {
        if (skipHiddenColumnsSetter)
            return;
        const hiddenColumns = getHiddenColumns(columns);
        const invisibleColumns = getInvisibleColumns(tableInstance.allColumns);
        if (hiddenColumns.length > invisibleColumns.length)
            tableInstance.setHiddenColumns(hiddenColumns);
    }, [columns, tableInstance, skipHiddenColumnsSetter]);
};
